import { fromJS, Map } from 'immutable';
import Actions from 'flow/actions';
import { listToMap } from 'flow/utils';

const initialState = Map();

export const socialIntegrationReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE:
            return initialState;
        case Actions.RESULT_SOCIAL_INTEGRATION_SETTINGS: {
            const socialIntegrationSettings = listToMap(
                fromJS(action.data),
                (e) => e.get('syncSource'),
            );
            return state.set(
                'socialIntegrationSettings',
                socialIntegrationSettings,
            );
        }
        case Actions.RESULT_SOCIAL_INTEGRATION_AUTH_IN_PROGRESS: {
            const syncSource = action.data;
            return state.setIn(
                [
                    'socialIntegrationSettings',
                    syncSource,
                    'clientAuthInProgress',
                ],
                true,
            );
        }
        case Actions.RESULT_SOCIAL_INTEGRATION_ERROR: {
            const socialIntegrationSettings = Map({ error: true });
            return state.set(
                'socialIntegrationSettings',
                socialIntegrationSettings,
            );
        }
        case Actions.RESULT_SOCIAL_INTEGRATION_CLOUD_FILES: {
            const cloudFilesData = fromJS(action.data);
            const stateWithStatus = state.setIn(
                ['cloudFiles', 'status'],
                cloudFilesData.get('status'),
            );
            return stateWithStatus.setIn(
                ['cloudFiles', cloudFilesData.get('chatSessionKey'), 'files'],
                cloudFilesData.get('files'),
            );
        }
        case Actions.RESULT_SOCIAL_INTEGRATION_CLOUD_FILES_STATUS: {
            const cloudFilesStatus = fromJS(action.data);
            return state.setIn(['cloudFiles', 'status'], cloudFilesStatus);
        }
        case Actions.RESULT_SOCIAL_INTEGRATION_CLOUD_FILES_CLEAR: {
            return state.remove('cloudFiles');
        }
        case Actions.RESULT_SOCIAL_INTEGRATION_EXTERNAL_SYNC: {
            return state.setIn(
                ['socialIntegrationSettings', 'externalSignInFinished'],
                action.syncIsDone,
            );
        }
        default: {
            return state;
        }
    }
};

export default socialIntegrationReducer;
